import { FileInfo } from '../../../generated';

export type ReviewDocumentDocumentInfo = Record<string, { title: string; url?: string; fileType?: string }>;

export const getDocumentInfo = (files: FileInfo[], DOCUMENT_CONFIG: ReviewDocumentDocumentInfo) => {
  return Object.entries(DOCUMENT_CONFIG).reduce(
    (acc, [key, config]) => ({
      ...acc,
      [key]: {
        title: config.title,
        ...getFileInfo(files, key)
      }
    }),
    {}
  );
};

function getFileInfo(files: FileInfo[], filename: string) {
  const file = files.find((f) => f?.name.split('/').pop() === filename);
  return {
    url: file?.url,
    fileType: file?.type
  };
}
